import { registerDecorator } from 'class-validator';
export function EarnRuleMaxCount(options, validationOptions) {
    return (object, propertyName) => {
        registerDecorator({
            name: 'EarnRuleMaxCount',
            target: object.constructor,
            propertyName,
            options: validationOptions,
            constraints: [options],
            validator: {
                validate(rules) {
                    return rules.filter(({ type }) => type === options.type).length <= options.quota;
                },
                defaultMessage() {
                    return `The maximum allowed number of ${options.type} rules is ${options.quota}`;
                },
            },
        });
    };
}
//# sourceMappingURL=EarnRuleMaxCount.js.map